"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.SectionTitle = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));
var _bind = _interopRequireDefault(require("classnames/bind"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _constants = require("../utils/constants");
var _CustomPropTypes = _interopRequireDefault(require("../utils/CustomPropTypes"));
var _Icon = require("../Icon/Icon");
var _Title = require("../Title/Title");
var _Section = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./Section.css") : void 0);
const _excluded = ["className", "headingLevel", "iconName", "iconClassName", "headingClassName", "titleIsHidden", "title"];
const CSS_BLOCK = 'sapcnqr-section';
const SectionTitle = props => {
  const {
      className,
      headingLevel = 2,
      iconName,
      iconClassName,
      headingClassName,
      titleIsHidden,
      title
    } = props,
    titleProps = (0, _objectWithoutProperties2.default)(props, _excluded);
  const classnames = _bind.default.bind(_Section.default);
  const headingClasses = classnames(_constants.CSS_PREFIX, `${CSS_BLOCK}__heading`, `${CSS_BLOCK}__heading--h${headingLevel}`, {
    [`${CSS_BLOCK}__heading--no-margin`]: titleIsHidden && !iconName
  }, headingClassName, className);
  const iconClasses = classnames(_constants.CSS_PREFIX, `${CSS_BLOCK}__heading-icon`, iconClassName);

  // Create the title element, which may or may not be an actual "element".
  // The only time it's an actual React element is if the title is supposed
  // to be hidden from view, in which case we wrap the title in a span and
  // apply the "sapcnqr-section--screen-reader-only" class to it. Otherwise, it's just text:
  const titleElement = titleIsHidden ? /*#__PURE__*/_react.default.createElement("span", {
    key: "section-title-element",
    className: classnames(_constants.CSS_PREFIX, `${CSS_BLOCK}--screen-reader-only`)
  }, title) : title;

  // If an icon name was supplied, construct the icon element:
  const iconElement = iconName && /*#__PURE__*/_react.default.createElement(_Icon.Icon, {
    ariaHidden: true,
    iconName: iconName,
    className: iconClasses,
    key: "section-icon-element"
  });

  // Now, create the heading children, which will either be the title or the
  // title PLUS the icon:
  const headingChildren = iconElement ? [iconElement, titleElement] : titleElement;
  return /*#__PURE__*/_react.default.createElement(_Title.Title, (0, _extends2.default)({}, titleProps, {
    className: headingClasses,
    headingLevel: headingLevel
  }), headingChildren);
};
exports.SectionTitle = SectionTitle;
SectionTitle.displayName = 'SectionTitle';
SectionTitle.propTypes = {
  title: _propTypes.default.node.isRequired,
  className: _propTypes.default.string,
  headingClassName: _propTypes.default.string,
  headingLevel: _CustomPropTypes.default.range(2, 6),
  iconName: _propTypes.default.string,
  iconClassName: _propTypes.default.string,
  titleIsHidden: _propTypes.default.bool
};
var _default = exports.default = SectionTitle;